module.exports = __webpack_public_path__ + "img/gh-36006-2.prt.788a476c.jpg";